import React from "react";
import HeroSection from "../HeroSection/HeroSection";
import SuccessSection from "../SuccessSection/SuccessSection";
import ServicesSection from "../ServicesSection/ServicesSection";
import CtaSection from "../CtaSection/CtaSection";
import WorkingProcess from "../WorkingProcess/WorkingProcess";
import StartProjectSection from "../StartProjectSection/StartProjectSection";

const Home = () => {
  return (
    <>
      <HeroSection />
      <SuccessSection />
      <ServicesSection />
      <CtaSection />
      <WorkingProcess/>
      <StartProjectSection/>
    </>
  );
};

export default Home;
